import { getContentstackImageURL } from '@noths/polaris-client-utils';
export var getImgSourcesByBreakpoint = function getImgSourcesByBreakpoint(imageSrcGetter, aspectRatioSizeSet) {
  return aspectRatioSizeSet.reduce(function (sources, set) {
    sources[set.breakpoint] = set.imgs.map(function (image) {
      return imageSrcGetter({
        width: image.width,
        aspectRatio: image.aspectRatio
      });
    });
    return sources;
  }, {});
};
export var generateImgSrcSet = function generateImgSrcSet(imgArray) {
  return imgArray.reduce(function (srcSet, image, i, arr) {
    var conjunction = arr.length > 1 ? i === 0 ? ' 1x,' : ' 2x' : '';
    return srcSet += image + conjunction;
  }, '');
};
export var contentStackImageSrcGetter = function contentStackImageSrcGetter(originalURL) {
  return function (_ref) {
    var aspectRatio = _ref.aspectRatio,
      width = _ref.width;
    return getContentstackImageURL(originalURL, width, {
      aspectRatio
    });
  };
};